module.exports = __webpack_public_path__ + "static/top_yum_bg-5b2cec4a392200c4a90243efcad38427.png";